import {me, UserInfo} from "../api/AuthApi";

let authCheckPromise: Promise<UserInfo | null> | null = null;
let isInitializing = false;

export const checkAuthStatus = async (): Promise<UserInfo | null> => {
    if (globalThis.location.pathname === '/login' ||
        globalThis.location.pathname.startsWith('/reset-password')) {
        return null;
    }

    if (authCheckPromise) {
        return authCheckPromise;
    }

    if (isInitializing) {
        await new Promise(resolve => setTimeout(resolve, 10));
        return checkAuthStatus();
    }

    isInitializing = true;

    authCheckPromise = me()
        .then(userInfo => userInfo)
        .catch(error => {
            console.log("Not logged in:", error);
            return null;
        })
        .finally(() => {
            isInitializing = false;
            setTimeout(() => {
                authCheckPromise = null;
            }, 100);
        });

    return authCheckPromise;
};